"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "login-wrapper w-full flex flex-col items-center justify-center" };
const _hoisted_2 = { class: "w-96 max-w-full px-4" };
const _hoisted_3 = { class: "p-8 flex items-center justify-center" };
const _hoisted_4 = ["src"];
const _hoisted_5 = ["onSubmit"];
const _hoisted_6 = {
    type: "submit",
    class: "w-full text-white uppercase font-bold text-lg bg-red rounded-md py-2"
};
const vue_3 = require("vue");
//inject,
const vue_router_1 = require("vue-router");
const Form_1 = require("../../components/Form");
const Alert_vue_1 = __importDefault(require("../../components/Alert.vue"));
const securityStore_1 = require("../../stores/security/securityStore");
//const T: VueTranslatorComponent | undefined = inject("Translator");
exports.default = (0, vue_1.defineComponent)({
    __name: 'Login',
    setup(__props) {
        const route = (0, vue_router_1.useRoute)();
        const router = (0, vue_router_1.useRouter)();
        const securityStore = (0, securityStore_1.useSecurityStore)();
        const email = (0, vue_3.ref)("");
        const password = (0, vue_3.ref)("");
        const errorMessage = (0, vue_3.ref)("");
        const onLogin = () => {
            securityStore
                .login(router, email.value, password.value)
                .then(() => {
                const redirect = router.resolve(route.query.redirect
                    ? `${route.query.redirect}`
                    : { name: "dashboard" });
                if (redirect.name) {
                    router.replace({ name: redirect.name });
                    return;
                }
                if (redirect.path) {
                    router.replace(redirect.path);
                    return;
                }
                router.replace(redirect);
            })
                .catch((error) => {
                errorMessage.value = error.toString();
            });
        };
        const onAlertDismissed = () => {
            errorMessage.value = "";
        };
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (errorMessage.value)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(Alert_vue_1.default, {
                        key: 0,
                        message: errorMessage.value,
                        icon: "",
                        dismissable: "",
                        onDismissed: onAlertDismissed
                    }, null, 8, ["message"]))
                    : (0, vue_2.createCommentVNode)("", true),
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    (0, vue_2.createElementVNode)("h1", _hoisted_3, [
                        (0, vue_2.createElementVNode)("img", {
                            src: require('../../images/marso-logo-fekvo-red.svg'),
                            alt: "MARSO",
                            class: "w-60"
                        }, null, 8, _hoisted_4)
                    ]),
                    (0, vue_2.createElementVNode)("form", {
                        onSubmit: (0, vue_2.withModifiers)(onLogin, ["prevent"])
                    }, [
                        (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.ShopInput), {
                            modelValue: email.value,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((email).value = $event)),
                            type: "email",
                            name: "email",
                            placeholder: _ctx.$trans('email', 'Email', 'login'),
                            autofocus: "",
                            required: "",
                            icon: "marso-icon-user",
                            class: "my-5"
                        }, null, 8, ["modelValue", "placeholder"]),
                        (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.ShopInput), {
                            modelValue: password.value,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((password).value = $event)),
                            type: "password",
                            name: "password",
                            placeholder: _ctx.$trans('password', 'Password', 'login'),
                            required: "",
                            icon: "marso-icon-lock",
                            class: "my-5"
                        }, null, 8, ["modelValue", "placeholder"]),
                        (0, vue_2.createElementVNode)("button", _hoisted_6, (0, vue_2.toDisplayString)(_ctx.$trans("sign_in", "Sign in", "login")), 1)
                    ], 40, _hoisted_5)
                ])
            ]));
        };
    }
});
